import React, { useState } from "react";
import { Button, ErrorMsg, Grid, Label, Toastify } from "atoms";

import { FormInput } from "molecules";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { useAuth } from "contexts/Auth";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email().required("Email is required"),
});

export const ProfileDetailForm = () => {
  const {
    state: { userData },
    actions: { updateUser },
  } = useAuth();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = (values, formikBag) => {
    setLoading(true);
    updateUser(values)
      ?.then(() => {
        Toastify("success", "Profile updated");
        formikBag?.resetForm();
      })
      .catch((e) => {
        setError(e?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Formik
      initialValues={{
        name: userData?.name || "",
        email: userData?.email || "",
        password: "",
        confirmPassword: "",
      }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {({ dirty, setFieldValue }) => {
        return (
          <Form>
            <Grid gridRowGap="2.4rem" mt="1.8rem" pr="12rem">
              <Grid gridRowGap="1.6rem">
                <Label text="Name" req />
                <FormInput
                  name="name"
                  type="text"
                  placeholder="Enter Name"
                  req
                  onChange={(e) => {
                    setFieldValue("name", e?.target?.value);
                    error && setError("");
                  }}
                />
              </Grid>
              <Grid gridRowGap="1.6rem">
                <Label text="Email" />
                <FormInput
                  name="email"
                  type="email"
                  placeholder="Enter Email"
                  disabled
                  req
                />
              </Grid>
              {error && <ErrorMsg text={error} />}

              <Button
                variant={dirty === true ? "primary" : "disabled"}
                loading={loading}
                type="submit"
                width="fit-content"
                px="3rem"
                height={{ xs: "4.3rem", lg: "4.8rem" }}
              >
                Save Profile
              </Button>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};
